import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, ChevronRight, LogIn, UserPlus } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import { useAuth } from '../../context/AuthContext';

const Header = () => {
  const { translations, language } = useLanguage();
  const { user } = useAuth();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navItems = [
    { label: translations.whoWeAre, href: '#who-we-are' },
    { label: translations.ourPrograms, href: '#programs' },
    { label: translations.takeAction, href: '#take-action' },
    { label: translations.eventsNav, href: '/events', isRoute: true },
    { label: translations.newsStories, href: '#news' },
  ];

  const loginLabel = language === 'fr' ? 'Se connecter' : 'Sign In';
  const registerLabel = language === 'fr' ? 'Créer un Profil' : 'Register';
  const dashboardLabel = language === 'fr' ? 'Mon compte' : 'My Account';

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 py-4 flex justify-between items-center">
        {/* Logo */}
        <a href="/" className="flex items-center gap-2">
          <img 
            src="https://customer-assets.emergentagent.com/job_talitha-koumi/artifacts/xsd39lyf_IMG-20260121-WA0012.jpg" 
            alt="TALITHA KOUMI TUG Logo" 
            className="h-20 w-auto object-contain"
          />
        </a>

        {/* Desktop Navigation */}
        <nav className="hidden lg:flex items-center gap-6">
          {navItems.map((item) => (
            item.isRoute ? (
              <Link
                key={item.label}
                to={item.href}
                data-testid={`header-nav-${item.label}`}
                className="text-[#1D1D1D] font-medium hover:text-[#D4AF37] transition-colors"
              >
                {item.label}
              </Link>
            ) : (
              <a
                key={item.label}
                href={item.href}
                className="text-[#1D1D1D] font-medium hover:text-[#D4AF37] transition-colors"
              >
                {item.label}
              </a>
            )
          ))}
          {user ? (
            <Link
              to={user.role === 'admin' || user.role === 'sub_admin' ? '/admin' : '/dashboard'}
              data-testid="header-dashboard-link"
              className="bg-[#D4AF37] text-white px-5 py-2.5 rounded-lg font-bold flex items-center gap-2 hover:bg-[#4d8a29] transition-colors text-sm"
            >
              {dashboardLabel}
            </Link>
          ) : (
            <Link
              to="/login"
              data-testid="header-login-link"
              className="text-[#1D1D1D] font-bold hover:text-[#D4AF37] transition-colors flex items-center gap-1 text-sm"
            >
              <LogIn className="w-4 h-4" /> {loginLabel}
            </Link>
          )}
          <Link
            to="/donate"
            data-testid="header-donate-link"
            className="bg-[#CD0000] text-white px-6 py-3 font-bold flex items-center gap-2 hover:bg-[#c91560] transition-colors"
          >
            {translations.donate} <ChevronRight className="w-4 h-4" />
          </Link>
        </nav>

        {/* Mobile Menu Button */}
        <button
          className="lg:hidden p-2"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {/* Mobile Navigation */}
      {mobileMenuOpen && (
        <div className="lg:hidden bg-white border-t">
          <nav className="flex flex-col">
            {navItems.map((item) => (
              item.isRoute ? (
                <Link
                  key={item.label}
                  to={item.href}
                  className="px-4 py-3 text-[#1D1D1D] font-medium hover:bg-gray-50 border-b"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {item.label}
                </Link>
              ) : (
                <a
                  key={item.label}
                  href={item.href}
                  className="px-4 py-3 text-[#1D1D1D] font-medium hover:bg-gray-50 border-b"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {item.label}
                </a>
              )
            ))}
            {user ? (
              <Link
                to={user.role === 'admin' || user.role === 'sub_admin' ? '/admin' : '/dashboard'}
                className="px-4 py-3 text-[#D4AF37] font-bold hover:bg-gray-50 border-b flex items-center gap-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                {dashboardLabel}
              </Link>
            ) : (
              <Link
                to="/login"
                className="px-4 py-3 text-[#1D1D1D] font-bold hover:bg-gray-50 border-b flex items-center gap-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                <LogIn className="w-4 h-4" /> {loginLabel}
              </Link>
            )}
            <Link
              to="/donate"
              className="m-4 bg-[#CD0000] text-white px-6 py-3 font-bold flex items-center justify-center gap-2"
              onClick={() => setMobileMenuOpen(false)}
            >
              {translations.donate} <ChevronRight className="w-4 h-4" />
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
